const data = {
  title: "Floor 3-1",
  musicTrack: "MUSIC_WORLD3",
  story: "FLOOR THREE - THE SLIPPERY SLOPE OF GREED",
  theme: "PINK",
  tilesWidth: 11,
  tilesHeight: 5,
  placements: [
    {
      type: "HERO_SPAWN",
      x: 2,
      y: 3
    },
    {
      type: "PLACEMENT_TYPE_GOAL",
      x: 10,
      y: 3
    },
    {
      type: "ICE",
      x: 6,
      y: 2
    },
    {
      type: "ICE",
      x: 6,
      y: 4
    },
    {
      type: "ICE",
      x: 8,
      y: 2,
      corner: "TOP_RIGHT"
    },
    {
      type: "ICE",
      x: 4,
      y: 2,
      corner: "TOP_LEFT"
    },
    {
      type: "ICE",
      x: 6,
      y: 3
    },
    {
      type: "ICE",
      x: 5,
      y: 3
    },
    {
      type: "ICE",
      x: 7,
      y: 3
    },
    {
      type: "ICE",
      x: 5,
      y: 2
    },
    {
      type: "ICE",
      x: 7,
      y: 2
    },
    {
      type: "ICE",
      x: 7,
      y: 4
    },
    {
      type: "ICE",
      x: 5,
      y: 4
    },
    {
      type: "CHIP",
      x: 4,
      y: 2
    },
    {
      type: "CHIP",
      x: 8,
      y: 2
    },
    {
      type: "ICE",
      x: 8,
      y: 4,
      corner: "BOTTOM_RIGHT"
    },
    {
      type: "ICE",
      x: 4,
      y: 4,
      corner: "BOTTOM_LEFT"
    },
    {
      type: "CHIP",
      x: 8,
      y: 4
    },
    {
      type: "CHIP",
      x: 4,
      y: 4
    },
    {
      type: "CHIP",
      x: 6,
      y: 3
    }
  ]
};

export default data;
